var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-page d-flex flex-column align-items-center justify-content-center"},[_c('div',[_vm._v("ERROR")]),_c('b-button',{attrs:{"variant":"danger","pill":""},on:{"click":_vm.retry}},[_vm._v(" Retry ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }